import { createContext } from 'react';
import { Session, User } from '@supabase/supabase-js';
import { type TierName, type TierLimits } from '@/lib/tierLimits';

export type AccessLevel = 'unauthenticated' | 'authenticated' | 'paid';

/** Stripe subscription status literals (matches Stripe.Subscription.Status) */
export type StripeSubscriptionStatus =
  | 'active'
  | 'past_due'
  | 'unpaid'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'trialing'
  | 'paused';

export interface AuthContextType {
  session: Session | null;
  user: User | null;
  loading: boolean;
  subscriptionTier: TierName;
  tierLimits: TierLimits;
  stripeProductId: string | null;
  stripeSubscriptionStatus: StripeSubscriptionStatus | null;
  subscriptionLoading: boolean;
  signOut: () => Promise<void>;
  hasAccess: (requiredTier: AccessLevel) => boolean;
  refreshSubscriptionStatus: () => Promise<TierName>;
  isAuthenticated: boolean;
  isPaidUser: boolean;
  isAdmin: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
